import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_bin_hdr_RowClass} from '../../../dbschema/bl_inv_bin_hdr.model';
import { bl_inv_bin_line_RowClass } from '../../../dbschema';

export class BinModel extends BaseContainerModel {
  bl_inv_bin_hdr: bl_inv_bin_hdr_RowClass = new bl_inv_bin_hdr_RowClass();
  bl_inv_bin_lines: bl_inv_bin_line_RowClass[] = [];
}
